import { GLSignUp } from '@group-link-one/grouplink-components';

import { useSignUp } from './useSignUp';

export const SignUp = () => {
  const { joinUser } = useSignUp();

  return <GLSignUp onSubmit={joinUser} />;
};
